module.exports.gen_comingsoon = {"EN":"Coming soon", "NL":"Binnenkort"};


// WEBPACK FOOTER //
// ./src/i18n.js